module.exports = __webpack_public_path__ + "media/slot-game/enjoy-14c25008.svg";